module.exports = __webpack_public_path__ + "img/data_analysis_bac4.2650494e.png";